import { useContext, useState, useEffect } from "react"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../../Components/OneInput/OneInput'
import { OneSwitch } from '../../../../Components/OneSwitch/OneSwitch'
import ComboBox from '../../../../Components/ComboBox/ComboBox'
import OneSelectCor from "../../../../Components/OneSelectCor/OneSelectCor"
import { prioridades, cores, tiposFechamento } from "../../../../Utils/optionsEventos"
import OneSelectPrioridade from "../../../../Components/OneSelectPrioridade/OneSelectPrioridade"
import ComboBoxEvento from "./ComboBoxEvento/ComboBoxEvento"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { pararAudio, showNotify, tocarAudio } from '../../../../Utils/Utils'
import OneModal from "../../../../Components/OneModal/OneModal"
import OneTextArea from "../../../../Components/OneTextArea/OneTextArea"
import OneSelect from "../../../../Components/OneSelect/OneSelect"
import { audiosEvento } from "../../../../Utils/optionsSelects"
import { PlayCircle, StopCircle } from "@mui/icons-material"
import { InputAutoCompleteCadastroEvento } from "./InputAutoCompleteCadastroEvento"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"

export const CadastroEvento = ({ openCadastro, setOpenCadastro, idToEdit, setIdToEdit, descricaoEvento }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { condominios } = useContext(CondominiosContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState({ morador: [], sindico: [] })
    const [eventosCheckados, setEventosCheckados] = useState({ morador: [], sindico: [] })

    const [equipes, setEquipes] = useState(null)
    const [eventos, setEventos] = useState(null)

    const [mostrarApp, setMostarApp] = useState(initialData?.mostrar_app || false)
    const [mostrarSind, setMostarSind] = useState(initialData?.mostrar_app_sindico || false)
    const [mostrar_todos_condominios_sindico, setMostrar_todos_condominios_sindico] = useState(initialData?.mostrar_todos_condominios_sindico || false)
    const [mostrar_todos_condominios_morador, setMostrar_todos_condominios_morador] = useState(initialData?.mostrar_todos_condominios_morador || false)
    const [notificaMorador, setNotificaMorador] = useState(initialData?.notifica_app || false)
    const [notificaSindico, setNotificaSindico] = useState(initialData?.notifica_app_sindico || false)

    const [mostrarSegundos, setMostrarSegundos] = useState(false)

    const [condominiosList, setCondominiosList] = useState([])

    const getDadosIniciais = (msg) => {
        if (msg.cmd == "buscarListagens") {
            if (msg.data.status == true) {
                setEquipes(msg.data.listagens.equipe)
                setEventos(msg.data.listagens.evento)
            } else if (msg.data.status == "error") {
                showNotify("error", msg.message)
                setOpenCadastro(false)
            } else if (msg.data.status == false) {
                showNotify("error", msg.message)
                setOpenCadastro(false)
            }
        } else if (msg.cmd == "buscarEvento") {
            if (msg.data.status) {
                if (msg.data.gravar_cameras && !msg.data.vai_para_tela) {
                    setMostrarSegundos(true)
                }
                setInitialData(msg.data)
            } else {
                showNotify(msg.message)
            }
        }
    }
    useEffect(() => {
        if (initialData && initialData.mostrar_todos_condominios_sindico !== undefined) {
            setMostrar_todos_condominios_sindico(initialData.mostrar_todos_condominios_sindico)
        }
        if (initialData && initialData.mostrar_todos_condominios_morador !== undefined) {
            setMostrar_todos_condominios_morador(initialData.mostrar_todos_condominios_morador)
        }
        if (initialData && initialData.mostrar_app_sindico !== undefined) {
            setMostarSind(initialData.mostrar_app_sindico)
        }
        if (initialData && initialData.mostrar_app !== undefined) {
            setMostarApp(initialData.mostrar_app)
        }
        if (initialData && initialData.notifica_app !== undefined) {
            setNotificaMorador(initialData.notifica_app)
        }
        if (initialData && initialData.notifica_app_sindico !== undefined) {
            setNotificaSindico(initialData.notifica_app_sindico)
        }
    }, [initialData?.mostrar_todos_condominios_morador, initialData?.mostrar_todos_condominios_sindico, initialData?.mostrar_app_sindico, initialData?.mostrar_app, initialData?.notifica_app, initialData?.notifica_app_sindico])

    useEffect(() => {
        if ((initialData || idToEdit == null) && equipes && eventos) {
            setLoading(false)
        }
    }, [initialData, eventos, equipes])

    useEffect(() => {
        addRoute("buscarListagens", getDadosIniciais)
        sendWs("buscarListagens", { listagens: { evento: ["id", "evento", "descricao"], equipe: ["id", "descricao"] } })
        let stringId = idToEdit != null ? `${idToEdit}` : null
        if (stringId != null) {
            addRoute("buscarEvento", getDadosIniciais)
            sendWs("buscarEvento", { id: stringId, listar: true })
        }
        if (condominios) {
            let result = condominios.map((cond) => {
                let objCond = { id_central: cond.id_central, nome: cond.nome }
                return objCond
            })
            setCondominiosList(result)
        }
    }, [])
    const responseSumbit = (msg) => {
        if (msg.data.status && msg.data.status !== 'error') {
            setIdToEdit(null)
            setOpenCadastro(false)
            showNotify("success", "Evento salvo com sucesso!")
            sendWs("buscarTodosEventos")
        } else if (!msg.data.status || msg.data.status == 'error') {
            showNotify("error", msg.data.message)
        }
    }
    addRoute("criarEvento", responseSumbit)
    addRoute("editarEvento", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        let mudancasMoradorinsert = formData.morador.every((item1, index) => item1 === eventosCheckados.morador[index])
        let mudancasMoradorDelete = eventosCheckados.morador.every((item1, index) => item1 === formData.morador[index])
        let mudancasSindicoInsert = formData.sindico.every((item1, index) => item1 === eventosCheckados.sindico[index])
        let mudancasSindicoDelete = eventosCheckados.sindico.every((item1, index) => item1 === formData.sindico[index])

        let mudancasGerais = mudancasMoradorinsert && mudancasSindicoInsert && mudancasMoradorDelete && mudancasSindicoDelete

        if (mudancasGerais) {
            delete formData.morador
            delete formData.sindico
            if (!formData || Object.keys(formData).length == 0) {
                showNotify("warning", "Nenhuma alteração feita!")
                setOpenCadastro(false)
                return
            }
        }

        if (formData.fechamento_auto_evento && (!formData.fechamento_auto_texto && !initialData.fechamento_auto_texto)) {
            showNotify("warning", "Preencha o texto de fechamento!")
            return
        }
        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            if (data.mostrar_app) {
                newData.descricao_app = data.descricao_app
            }
            if (data.mostrar_app_sindico) {
                newData.descricao_app_sindico = data.descricao_app_sindico
            }
            if (formData.morador && formData.morador.length > 0) {
                newData.morador = EventosCondominiosApp('morador')
            }
            if (formData.sindico && formData.sindico.length > 0) {
                newData.sindico = EventosCondominiosApp('sindico')
            }
            if (formData.sindico && formData.sindico.length == 0 && eventosCheckados.sindico.length > 0) {
                newData.sindico = EventosCondominiosApp('sindico')
            }
            if (formData.sindico && formData.morador.length == 0 && eventosCheckados.morador.length > 0) {
                newData.morador = EventosCondominiosApp('morador')
            }

            if (data.mostrar_tela_visitante) {
                newData.mostrar_tela_visitante = data.mostrar_tela_visitante
            }

            data = newData
            sendWs("editarEvento", { evento: data })
        } else {
            if (!data.prioridade) {
                data.prioridade = 1
            }
            delete data.id
            sendWs("criarEvento", { evento: data })
        }
    }

    const EventosCondominiosApp = (tipo) => {
        let data = {
            delete: {
                id: []
            },
            inserts: {
                id_evento: idToEdit,
                tipo: ''
            }
        }

        if (tipo == 'morador') {
            data.inserts.tipo = 0
        } else {
            data.inserts.tipo = 1
        }

        const itemRemovido = eventosCheckados[tipo].filter(item1 => {
            const encontrado = formData[tipo].some(item2 => item1.id === item2.id)
            return !encontrado
        })
        if (itemRemovido.length > 0) {
            const id_central_delete = itemRemovido.map(item => item.id)
            data.delete.id = id_central_delete
        }

        const insert = formData[tipo].filter(item1 => {
            const encontrado = eventosCheckados[tipo].some(item2 => item1.id_central === item2.id_central)
            return !encontrado
        })
        if (insert.length > 0) {
            const id_central_insert = insert.map(item => item.id_central)
            data.inserts.ids_centrais = id_central_insert
        }
        return data
    }

    const changeMostrarApp = () => {
        setMostarApp(!mostrarApp)
    }
    const changeMostrarSind = () => {
        setMostarSind(!mostrarSind)
    }
    const changeMostrarTodosCondominiosAppSindico = () => {
        setMostrar_todos_condominios_sindico(!mostrar_todos_condominios_sindico)
    }
    const changeMostrarTodosCondominiosAppMorador = () => {
        setMostrar_todos_condominios_morador(!mostrar_todos_condominios_morador)
    }
    const changeNotificarMorador = () => {
        setNotificaMorador(!notificaMorador)
    }
    const changeNotificarSindico = () => {
        setNotificaSindico(!notificaSindico)
    }

    const [testando, setTestando] = useState(false)

    const testarSom = () => {
        let evento = initialData?.id || -1
        let audio = formData?.tocar_som || initialData?.tocar_som
        if (!audio || audio == "0") {
            showNotify("warning", "Selecione um som!")
            return
        }
        if (audio) {
            if (!testando) {
                setTestando(true)
                tocarAudio(audio, evento, () => { setTestando(false) })
            } else if (testando) {
                setTestando(false)
                pararAudio(evento, () => { setTestando(true) })
            }
        }
    }

    const getIcon = (testando) => {
        return testando
            ? <StopCircle
                key={testando}
                sx={{ color: '#8A05BE' }}
                onClick={() => { testarSom() }}
            />
            : <PlayCircle
                key={testando}
                sx={{ color: '#8A05BE' }}
                onClick={() => { testarSom() }}
            />
    }

    useEffect(() => {
        let gravarCameras = formData?.gravar_cameras != undefined ? formData?.gravar_cameras : initialData?.gravar_cameras
        let vaiParaTela = formData?.vai_para_tela != undefined ? formData?.vai_para_tela : initialData?.vai_para_tela

        if (!gravarCameras || (gravarCameras && vaiParaTela)) {
            setMostrarSegundos(false)
        } else {
            setMostrarSegundos(true)
        }
    }, [formData?.gravar_cameras, formData?.vai_para_tela])

    const getWsResponse = (msg) => {
        let eventos = msg.data
        if (eventos.status) {
            if (eventos.eventos.morador !== undefined) {
                listCheck(eventos.eventos.morador, 0)
            }
            if (eventos.eventos.sindico !== undefined) {
                listCheck(eventos.eventos.sindico, 1)
            }
        }
        setLoading(false)
    }

    useEffect(() => {
        if (condominiosList.length > 0) {
            let condominios = condominiosList.map(cond => cond.id_central)
            let condString = condominios.toString()

            const commonParams = { id_central: condString, id_evento: idToEdit }
            sendWs("getEventosCondominiosApp", { ...commonParams })
            addRoute("getEventosCondominiosApp", getWsResponse)
        }
    }, [condominiosList])

    const listCheck = (eventos, tipo) => {
        if (eventos) {
            if (condominiosList.length > 0) {
                const idCentralNaoRepetidos = new Set()

                eventos.forEach((cond) => {
                    idCentralNaoRepetidos.has({ id: cond.id, id_central: cond.id_central })
                    idCentralNaoRepetidos.add({ id: cond.id, id_central: cond.id_central })
                })
                let conjunto = [...idCentralNaoRepetidos]

                let conds = conjunto.map((evento) => {
                    let id = evento.id
                    const condCheck = condominiosList.find((cond) => cond.id_central == evento.id_central)
                    if (condCheck) {
                        return { id_central: condCheck.id_central, nome: condCheck.nome, id }
                    }
                })
                if (tipo == 0) {
                    if (conds.length > 0) {
                        setFormData(prev => ({ ...prev, morador: conds }))
                        setEventosCheckados(prev => ({ ...prev, morador: conds }))
                    }
                } else if (tipo == 1) {
                    if (conds.length > 0) {
                        setFormData((prev) => ({ ...prev, sindico: conds }))
                        setEventosCheckados(prev => ({ ...prev, sindico: conds }))
                    }
                }
            }
        }
        setLoading(false)
    }
    const handleCondominiosMorador = (e, newEventos) => {
        setFormData({ ...formData, morador: newEventos })
    }
    const handleCondominiosSindico = (e, newEventos) => {
        setFormData({ ...formData, sindico: newEventos })
    }
    return (
        <OneModal
            open={openCadastro}
            setOpen={setOpenCadastro}
            loading={loading}
            titleText="Evento"
            FooterButtons={FooterButtons}
            fullWidth={true}
        >
            {!loading &&
                <form
                    id="eventos-form"
                    onSubmit={handleSubmit}
                >
                    <Grid
                        xs={12}
                        columnSpacing={1}
                        rowGap={0.5}
                        container
                        sx={{ width: '100%', height: '100%' }}
                    >
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}>
                            <Grid container xs={12} md={5} lg={4} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={3} lg={4}>
                                    <Typography fontSize="13px" fontWeight='400' >Codigo: </Typography>
                                </Grid>
                                <Grid xs={12} md={8} lg={7.5}>
                                    <OneInput
                                        onChange={handleChange}
                                        readOnly={true}
                                        disabled={true}
                                        defaultValue={initialData?.id}
                                        name={"id"}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} md lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={2} lg={1.5}>
                                    <Typography fontSize="13px" fontWeight='400' >*Evento: </Typography>
                                </Grid>
                                <Grid xs={12} md lg>
                                    <OneInput
                                        onChange={handleChange}
                                        autoFocus maxLength="4"
                                        transform="uppercase"
                                        disabled={initialData?.id > 0}
                                        required
                                        defaultValue={initialData?.evento}
                                        name={"evento"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}>
                            <Grid xs={12} lg={1.35}>
                                <Typography fontSize="13px" fontWeight='400' >*Descrição: </Typography>
                            </Grid>
                            <Grid xs={12} lg>
                                <OneInput onChange={handleChange} maxLength="60" required defaultValue={initialData?.descricao} name={"descricao"} />
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}>
                            <Grid container xs={12} lg={4} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={4}>
                                    <Typography fontSize="13px" fontWeight='400' >*Prioridade: </Typography>
                                </Grid>
                                <Grid xs={12} lg={7.5}>
                                    <OneSelectPrioridade onChange={handleChange} options={prioridades} defaultValue={initialData?.prioridade} name={"prioridade"} />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg={3.5} sx={{ alignItems: 'center' }}>
                                <OneSwitch
                                    onChange={handleChange}
                                    defaultValue={initialData?.vai_para_tela}
                                    name={"vai_para_tela"}
                                />
                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Vai para o Monitoramento </Typography>
                            </Grid>
                            {/* <Grid container xs={12} lg={2} sx={{ alignItems: 'center' }}>
                                <OneSwitch
                                    onChange={handleChange}
                                    defaultValue={initialData?.vai_para_tela}
                                    name={"vai_para_tela"}
                                />
                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Gravar câmera </Typography>
                            </Grid> */}
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Cor da borda: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    <OneSelectCor onChange={handleChange} options={cores} defaultValue={initialData?.cor_borda} name={"cor_borda"} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }}>
                            <Grid container xs={12} sm={2.5} sx={{ alignItems: 'center' }}>
                                <Grid container xs={12} sx={{ alignItems: 'center' }}>
                                    <OneSwitch onChange={(event) => { handleChange(event) }} defaultValue={initialData?.descartar} name={"descartar"} />
                                    <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >*Descartar evento </Typography>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <OneSwitch
                                    onChange={handleChange}
                                    defaultValue={initialData?.agrupar}
                                    name={"agrupar"}
                                />
                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Agrupar </Typography>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <OneSwitch
                                    onChange={handleChange}
                                    defaultValue={initialData?.gerar_manual}
                                    name={"gerar_manual"}
                                />
                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Evento manual </Typography>
                            </Grid>
                        </Grid>

                        <Grid container xs={12} sx={{ alignItems: 'center', padding: '10px 0' }}>
                            <Grid container xs={12} lg={3} sx={{ alignItems: 'center' }}>
                                <OneSwitch
                                    onChange={handleChange}
                                    defaultValue={initialData?.gravar_cameras}
                                    name={"gravar_cameras"}
                                />
                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Gravar câmeras do evento </Typography>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center', visibility: (mostrarSegundos ? 'show' : 'hidden') }}>
                                <OneInput
                                    newSx={{ width: '60px' }}
                                    type="number"
                                    min="0"
                                    step="1"
                                    onChange={handleChange}
                                    defaultValue={initialData?.segundos_gravacao}
                                    name={"segundos_gravacao"}
                                />
                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Seg.</Typography>
                            </Grid>
                            {
                                initialData?.evento == 'OACC' &&
                                <Typography fontSize="13px" fontWeight='400' sx={{ color: '#f1970f' }}>
                                    <b>Atenção:</b> Para que a gravação funcione é necessário que a opção <b>OACC para Replays</b> também esteja habilitada na configuração de cada condomínio
                                </Typography>
                            }

                        </Grid>

                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}> {/* linha */}
                            <Grid container xs={12} lg={6} sx={{ alignItems: 'center' }}> {/* sessao */}
                                <Grid xs={12} lg={2}> {/* elemento */}
                                    <Typography fontSize="13px" fontWeight='400' >Equipe: </Typography>
                                </Grid>
                                <Grid xs={12} lg={9.5}>{/* elemento */}
                                    {
                                        equipes &&
                                        <ComboBox onChange={handleChange} options={equipes} defaultValue={initialData?.id_equipe} name={"id_equipe"} />
                                    }
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={3}>
                                    <Typography fontSize="13px" fontWeight='400' >Tocar Som: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    {
                                        audiosEvento &&
                                        <ComboBox
                                            onChange={handleChange}
                                            options={audiosEvento}
                                            defaultValue={initialData?.tocar_som}
                                            name={"tocar_som"}
                                        />
                                    }
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg={1} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                                {getIcon(testando)}
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}>
                            <Grid container xs={12} lg={4.5} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={3} lg={7.3}>
                                    <Typography fontSize="13px" fontWeight='400' >Tempo médio atendimento: </Typography>
                                </Grid>
                                <Grid xs={12} sm={9} lg={4.3}>
                                    <OneInput
                                        onChange={handleChange}
                                        type={"time"}
                                        step="1"
                                        defaultValue={initialData?.tempo_medio_atendimento}
                                        name={"tempo_medio_atendimento"}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg={4} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={3} lg={6.5}>
                                    <Typography fontSize="13px" fontWeight='400' >Tempo médio espera: </Typography>
                                </Grid>
                                <Grid xs={12} sm={9} lg={5.3}>
                                    <OneInput
                                        onChange={handleChange}
                                        type={"time"}
                                        step="1"
                                        defaultValue={initialData?.tempo_medio_espera}
                                        name={"tempo_medio_espera"}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={3} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Atraso ir tela: </Typography>
                                </Grid>
                                <Grid xs={12} sm={9} lg={7}>
                                    <OneInput
                                        onChange={handleChange}
                                        type={"time"}
                                        step="1"
                                        defaultValue={initialData?.tempo_atraso_tela}
                                        name={"tempo_atraso_tela"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }}>
                            <Grid container xs={12} >
                                <Grid xs={12} lg={2}>
                                    <Typography fontSize="13px" fontWeight='400' >*Procedimento: </Typography>
                                </Grid>
                                <Grid xs={12} lg={10}>
                                    <OneTextArea
                                        onChange={handleChange}
                                        defaultValue={initialData?.procedimento} name={"procedimento"}
                                        multiline="true"
                                        maxRows={3}
                                        textarea="true"
                                        maxLength={1000}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* <Grid container xs={12} sx={{ alignItems: 'center' }}>
                            <Grid container xs={12} sm={2.5} sx={{ alignItems: 'center' }}>
                                <Grid container xs={12} sx={{ alignItems: 'center' }}>
                                    <OneSwitch onChange={(event) => { handleChange(event) }} defaultValue={initialData?.descartar} name={"descartar"} />
                                    <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >*Descartar evento </Typography>
                                </Grid>
                            </Grid>
                            <Grid container xs sm sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={3}>
                                    <Typography fontSize="13px" fontWeight='400' >*Tipo de fechamento: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    <OneSelect
                                        defaultValue={initialData?.tipo_fechamento}
                                        options={tiposFechamento}
                                        onChange={handleChange}
                                        name={"tipo_fechamento"}
                                        valor={"value"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid> */}
                        <Grid container xs={12} sx={{ alignItems: 'center' }}>
                            <Grid container xs={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={4.5}>
                                    <Typography fontSize="13px" fontWeight='400' >*Fechar automático ao receber o evento: </Typography>
                                </Grid>
                                <Grid xs={12} lg={7.5}>
                                    {
                                        eventos &&
                                        <ComboBoxEvento
                                            callback={handleChange}
                                            options={eventos}
                                            defaultValue={initialData?.fechamento_auto_evento} name={"fechamento_auto_evento"}
                                            eventoEdicao={initialData?.evento}
                                            // callback={changeFechamentoAuto}
                                        />
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }}>
                            <Grid container xs={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={4.5}>
                                    <Typography fontSize="13px" fontWeight='400' >*Tipo de fechamento: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    <OneSelect
                                        defaultValue={initialData?.tipo_fechamento || "0"}
                                        options={tiposFechamento}
                                        onChange={handleChange}
                                        name={"tipo_fechamento"}
                                        valor={"value"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }}>
                            <Grid container xs={12} >
                                <Grid xs={12} lg={4.5}>
                                    <Typography fontSize="13px" fontWeight='400' >*Texto para fechamento automático: </Typography>
                                </Grid>
                                <Grid xs={12} lg={7.5}>
                                    <OneTextArea onChange={handleChange}
                                        defaultValue={initialData?.fechamento_auto_texto} name={"fechamento_auto_texto"}
                                        maxRows={3}
                                        textarea="true"
                                        maxLength={300}
                                    // disabled={!fechamentoAuto}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {initialData && (initialData.evento == 'OINI' || initialData.evento == 'OVIS') &&
                            <Grid>
                                <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                    <OneSwitch
                                        onChange={handleChange}
                                        defaultValue={initialData?.mostrar_tela_visitante}
                                        name={"mostrar_tela_visitante"}
                                    />
                                    <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >
                                        Ir para tela de visitante ao selecionar evento
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        <Grid sx={{ width: '100%' }}>
                            {descricaoEvento == 'OACC'
                                ? ''
                                : <fieldset>
                                    <legend>Síndico App</legend>
                                    <Grid container xs={12} sx={{ alignItems: 'center', width: '100%' }}>
                                        <Grid sx={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                                            <Grid container xs={1} sm={4} sx={{ alignItems: 'center' }}>
                                                <OneSwitch onChange={(event) => { handleChange(event); changeMostrarSind() }} defaultValue={initialData?.mostrar_app_sindico} name={"mostrar_app_sindico"} />
                                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >*Mostrar evento no histórico do app </Typography>
                                            </Grid>
                                            <Grid container xs={2} sm={2.5} sx={{ alignItems: 'center' }}>
                                                <OneSwitch onChange={(event) => { handleChange(event); changeNotificarSindico() }} defaultValue={initialData?.notifica_app_sindico} name={"notifica_app_sindico"} />
                                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Notificar no app </Typography>
                                            </Grid>
                                            <Grid xs={5} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                <Grid xs={6} sm={3} lg={3.4}>
                                                    <Typography fontSize="13px" fontWeight='400' >*Descrição: </Typography>
                                                </Grid>
                                                <Grid xs={12} sm={8} lg={8.6} sx={{ overflow: 'hidden', width: '100%', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <OneInput newSx={{ overflow: 'hidden', textOverflow: 'ellipsis' }} onChange={handleChange} disabled={!notificaSindico} required={false} maxLength={150} defaultValue={initialData?.descricao_app_sindico} name={"descricao_app_sindico"} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid xs={12} marginTop={2} sx={{ display: mostrarSind || notificaSindico ? 'flex' : 'none', width: '100%' }}>
                                            <Grid xs={6} sm={9}>
                                                <InputAutoCompleteCadastroEvento disabled={mostrar_todos_condominios_sindico} handleFiltroEventos={handleCondominiosSindico} condominiosList={condominiosList} dados={formData.sindico} ></InputAutoCompleteCadastroEvento>
                                            </Grid>
                                            <Grid container xs={6} sm={3} sx={{ display: 'flex', alignItems: 'center', marginLeft: '10px', marginTop: '20px' }}>
                                                <OneSwitch onChange={(event) => { handleChange(event); changeMostrarTodosCondominiosAppSindico() }} disabled={!mostrarSind && !notificaSindico} defaultValue={initialData?.mostrar_todos_condominios_sindico} name={"mostrar_todos_condominios_sindico"} />
                                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Todos os Condominios </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </fieldset>
                            }
                        </Grid>
                        <Grid sx={{ width: '100%' }}>
                            {descricaoEvento == 'OACC'
                                ? ''
                                : <fieldset>
                                    <legend>Morador App</legend>
                                    <Grid container xs={12} sx={{ alignItems: 'center', width: '100%' }}>
                                        <Grid sx={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                                            <Grid container xs={1} sm={4} sx={{ alignItems: 'center' }}>
                                                <OneSwitch onChange={(event) => { handleChange(event); changeMostrarApp() }} defaultValue={initialData?.mostrar_app} name={"mostrar_app"} />
                                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >*Mostrar evento no histórico do app</Typography>
                                            </Grid>
                                            <Grid container xs={2} sm={2.5} sx={{ alignItems: 'center' }}>
                                                <OneSwitch onChange={(event) => { handleChange(event); changeNotificarMorador() }} defaultValue={initialData?.notifica_app} name={"notifica_app"} />
                                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Notificar no app </Typography>
                                            </Grid>
                                            <Grid xs={5} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                <Grid item xs={6} sm={3} lg={3.4} sx={{ marginRight: '5px' }}>
                                                    <Typography fontSize="13px" fontWeight='400' >*Descrição: </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={8} lg={8.6} sx={{ overflow: 'hidden', width: '100%', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <OneInput newSx={{ overflow: 'hidden', textOverflow: 'ellipsis' }} onChange={handleChange} disabled={!notificaMorador} required={false} maxLength={150} defaultValue={initialData?.descricao_app} name={"descricao_app"} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid xs={12} marginTop={2} sx={{ display: mostrarApp || notificaMorador ? 'flex' : 'none' }}>
                                            <Grid xs={6} sm={9}>
                                                <InputAutoCompleteCadastroEvento handleFiltroEventos={handleCondominiosMorador} disabled={mostrar_todos_condominios_morador} condominiosList={condominiosList} dados={formData.morador} ></InputAutoCompleteCadastroEvento>
                                            </Grid>
                                            <Grid container xs={6} sm={3} sx={{ displey: 'flex', alignItems: 'center', marginLeft: '10px', marginTop: '20px' }} >
                                                <OneSwitch onChange={(event) => { handleChange(event); changeMostrarTodosCondominiosAppMorador() }} defaultValue={initialData?.mostrar_todos_condominios_morador} name={"mostrar_todos_condominios_morador"} />
                                                <Typography style={{ marginLeft: '10px' }} fontSize="13px" fontWeight='400' >Todos os Condominios </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </fieldset>
                            }
                        </Grid>
                    </Grid>
                </form >
            }
        </OneModal >
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="eventos-form" type="submit">Salvar</Button>
        </Grid>
    )
}
